<template>
  <span>
    <!--<button class="search-trigger"><i class="fa fa-search"></i></button>-->
    <!--<div class="form-inline">-->
    <!--<form class="search-form">-->
    <!--<input class="form-control mr-sm-2" type="text" placeholder="Search ..." aria-label="Search">-->
    <!--<button class="search-close" type="submit"><i class="fa fa-close"></i></button>-->
    <!--</form>-->
    <!--</div>-->
<span>
                       <template v-if="true">

                      <!--<div class="row form-group">-->
                         <!--<div class="col col-md-3"><label for="companySelector" class=" form-control-label">{{ $t('clouduser.shop') }} {{ $t('clouduser.shop_extra') }}</label></div>-->
                         <!--<div class="col-12 col-md-9">-->
                         <!--{{usercompanies}}-->
                          <select id="companySelector" class="form-control companySelector companySelectorCssHack" v-model="data.id_company" name="data.id_stores"
                                  v-bind:class="{'is-invalid': errors.has('data.id_company')}">

                            <!--<option value="">{{$t('form.pleasechoose')}} </option>-->

                            <template v-if="Array.isArray(usercompanies) &&usercompanies.length>0">
                              <template v-for="(row, i) in usercompanies">
                                <option :value="row.id">{{row.company_name}}</option>
                              </template>
                            </template>

                          </select>
                         <!--</div>-->
                         <!--</div>-->
                    </template>
</span>
    <!--<button class="search-trigger"><i class="fa fa-search"></i></button>-->
    <!--<div class="form-inline">-->
    <!--<form class="search-form">-->


    <!--<input class="form-control mr-sm-2" type="text" placeholder="Search ..." aria-label="Search">-->
    <!--<button class="search-close" type="submit"><i class="fa fa-close"></i></button>-->
    <!--</form>-->
    <!--</div>-->

  </span>
</template>

<script>
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';
  import Api from "@/api/Api";

  export default {
    name: 'HeaderCompanySelector',
    data(){
      return {
        data: {
          id_company: ""
        },
        user: {},
        companymodules: [],
        usercompanies: [],
        userrolesforcompany: [],
        Helper: Helper,
        HelperRole: HelperRole,
      }
    },
    watch: {
      "data.id_company": function (newData, oldData) {
        if (String(newData) !== "" && String(newData) !== "null" && String(newData) !== "undefined" && newData !== oldData) {
          console.log(newData);
          this.setCompany(newData);
        }
      },
      "$store.state.userhash": function (newData, oldData) {
        if (String(newData) !== "" && String(newData) !== "null" && String(newData) !== "undefined" && newData !== oldData) {
//          console.log(newData);
          this.makeSelectorData();
        }
      },
      "$store.state.id_company": function (newData, oldData) {
        if (String(newData) !== "" && String(newData) !== "null" && String(newData) !== "undefined" && newData !== oldData) {
//          console.log(newData);
          this.makeSelectorData();
        }
      },
      '$store.state.usercompanieshash': function (newVal, oldVal) {
        const modul = this;
        modul.usercompanies = modul.$store.state.usercompanies;
      },
//      '$store.state': function (newVal, oldVal) {
//        const modul = this;
//        modul.usercompanies = modul.$store.state.usercompanies;
//      },
    },
    mounted() {
      const modul = this;
      modul.makeSelectorData();
    },
    methods: {
      makeSelectorData(){
        const modul = this;
//        console.log(modul.$store.state.id_company);
        if (modul.data.id_company !== String(modul.$store.state.id_company)) {
          modul.data.id_company = (modul.$store.state.id_company) ? String(modul.$store.state.id_company) : "";
        }
        if (modul.$store.state.usercompanies) {
          modul.usercompanies = modul.$store.state.usercompanies;
        }
        if (modul.usercompanies && Array.isArray(modul.usercompanies) && modul.usercompanies.length === 1 && modul.usercompanies[0].company_id && !modul.data.id_company) {
          modul.data.id_company = modul.usercompanies[0].company_id;
          modul.setCompany(modul.data.id_company);
        }
      },
      setCompany(newData){
        const modul = this;
//        console.log("BEFUTOTT-000");
        const id_company = (newData) ? newData : null;

        if (id_company) {
//          console.log("BEFUTOTT-111");
//          console.log(modul.$store.state.user.id_company_actual);
//          console.log(id_company);
          if (modul.$store.state.user && id_company && modul.$store.state.id_company !== id_company) { //  modul.$store.state.user.id_company_actual &&  && id_company

//            console.log("BEFUTOTT-1xxx");
//            const id_company = (id_company) ? id_company : null;
            Api.setMyCompany({id: id_company, id_company: modul.$store.state.id_company}).then(function (res) {
//              console.log("BEFUTOTT-222");
              if (res && res.data && res.result === true) {
                if (res && res.data.usercompanies) {
                  modul.$store.state.usercompanies = res.data.usercompanies;
                }
              }
              modul.$store.state.id_company = id_company;
              if (modul.$store.state.user) { //  && modul.$store.state.user.role !== "ADMIN"
//                console.log("BEFUTOTT-333");
                Api.healthCheck({id_company: modul.$store.state.id_company}).then(function (res) {
//                    console.log("BEFUTOTT-444");
                    HelperRole.healthCheckHandler(modul, res);
                    modul.data.id_company = modul.$store.state.id_company;
                  }
                );
              }
            });
          }
        }
      },
    }
  }
</script>

<style>
  .companySelector.companySelectorCssHack {
    display: inline-block;
    width: auto;
  }
</style>

